whenAvailable('$', function() {
  $(function () {
      $.updateNotifyV2 = function(e) {
          var sku = $(e).attr('data-sku'),
              status = $(e).attr('data-status'),
              notify_container = $('.notify-v2');

          if ( $(e).parents('.atc-item-wrapper').find('.notify-v2').length > 0 ) {
              notify_container = $(e).parents('.atc-item-wrapper').find('.notify-v2');
          } else if ( notify_container.parents('.atc-item-wrapper').length > 0 ) {
              return;
          }

          if ( status == 'out-of-stock' || status == 'not-available' || status == 'coming-soon' || status == 'register-interest' ) {
              notify_container.attr('data-sku', sku).attr('data-status', status).stop().slideDown(function() {
                  $(this).attr('style', 'display: block;');
              });
          } else {
              notify_container.stop().slideUp(function() {
                  $(this).attr('data-sku', '').attr('data-status', '').attr('style', '');
              });
          }
      }

      whenAvailable('secretlabATC', function() {
          if ( $('.notify-v2[data-update="atc-item"]').length > 0 ) {
              // INITIALIZE NOTIFY V2
              target = $('.atc-item-variant.active[data-status="out-of-stock"], .atc-item-variant.active[data-status="not-available"], .atc-item-variant.active[data-status="coming-soon"]');
              if ( $(target).length > 0 ) {
                  $.updateNotifyV2(target);
              }

              // BIND NOTIFY V2 TO ATC-ITEM UPDATE
              $('body').on('click', 'button.atc-item-variant:not([data-notify-popup])', function(e) {
                  if ( !$('body').hasClass('drawer-open') || !$('body').hasClass('template-collection') ) {
                      $.updateNotifyV2(this);
                  }
              }).on('click', '.selector-initialize-mobile', function() {
                  $.updateNotifyV2($('.atc-item-variant[data-variant-id="' + $('.selector-initialize-mobile').attr('data-variant-id') + '"]'));
              });
          }
      });

      // SHOW NOTIFY V2 IF data-update="never" and out-of-stock/not-available
      if ( $('.notify-v2[data-update="never"][data-status="out-of-stock"], .notify-v2[data-update="never"][data-status="not-available"], .notify-v2[data-update="never"][data-status="coming-soon"]').length > 0 ) {
          $('.notify-v2').show();
      }

      // DETECT AND APPEND NOTIFY V2 IF DATA-NOTIFY-POPUP IS FOUND
      // BIND DATA-NOTIFY-POPUP EVENT
      if ( $('[data-notify-popup]').length > 0 ) {
          $.ajax({
              dataType: "html",
              url: locale_root + "/?view=notify",
          }).then(function(data) {
              $('body').append(data);
          });

          // [data-notify-popup]="sku, status"
          $('body').on('click', '[data-notify-popup]', function(){
              var sku = $(this).attr('data-sku'),
                  status = $(this).attr('data-status');
              $('.notify-v2[data-update="popup"]').attr('data-sku', sku).attr('data-status', status);
              $('#notify_v2_popup').modal('show');
          });
      }

      // BIND NOTIFY V2 TO ATC-ITEM UPDATE
      $('body').on('click', '.notify-v2 button.register', function(e){
          e.preventDefault();

          var _parent = $(e.target).parents('.notify-v2'),
              email_address = _parent.find('input[type="email"]').val(),
              current_status = _parent.attr('data-status');

          if (current_status == 'coming-soon' || current_status == 'register-interest') {
              current_status = 'not-available'
          }

          _parent.find('.response').stop().slideUp();
          _parent.find('.email-error-message').html('');
          _parent.find('input[type="email"]').removeClass('border border-danger');
          if ('' === email_address) {
              _parent.find('input[type="email"]').focus();
          } else if (!email_address.toLowerCase()
            .match(
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            _parent.find('input[type="email"]').focus().addClass('border border-danger');
            _parent.find('.email-error-message').html('Email address is invalid');
          } else {
              _parent.find('button.register').prop('disabled', true);
              const payload = {
                  store_code: store_code,
                  email_address: email_address,
                  shopify_variant_sku: _parent.attr('data-sku'),
                  current_status: current_status
              }
              $.post('https://beans.secretlab.co/index.php/api/restock_notification', payload, function (data) {
                  if ('ok' === data.status) {
                      _parent.find('.response.success').stop().slideDown();
                      _parent.find('.input[type="email"]').val('');
                  } else {
                      // we don't need to show error message, we still show success message but trigger sentry alert
                      // _parent.find('.response.error').stop().slideDown();
                      _parent.find('.response.success').stop().slideDown();
                      _parent.find('.input[type="email"]').val('');
                      if (typeof Sentry != 'undefined' ) {
                          Sentry.captureException(new Error(`Failed to register restock notification JSON: ${JSON.stringify(payload)}`), (scope) => {
                              scope.setLevel('fatal');
                              return scope;
                          });
                      }
                  }
                  _parent.find('button.register').prop('disabled', false);
              }, 'json');
          }
      })

      window.notify_v2 = [];
  });

  function updateNotifyV2() { $.updateNotifyV2(); }
});
